module.exports = __webpack_public_path__ + "static/img/5.cb9bf895.png";